(function () {
    'use strict';

    angular
        .module('surveyCampaignControllers')
        .controller('SidebarCampaignController', Controller);

    Controller.$inject = ['$scope', 'campaign'];

    function Controller($scope, campaign) {

        $scope.campaign = campaign;

        $scope.exportAnonymized = function (exportFormat) {
            submitReport('Anonymized', exportFormat);
        }

        $scope.exportNonAnonymized = function (exportFormat) {
            submitReport('NonAnonymized', exportFormat);
        }

        $scope.exportAnonymizedData = function (exportFormat) {
            submitReport('AnonymizedData', exportFormat);
        }

        $scope.exportNonAnonymizedData = function (exportFormat) {
            submitReport('NonAnonymizedData', exportFormat);
        }

        function submitReport(reportType, exportFormat) {
            var urlToDownload = '/Survey/Reporting/' +
                                reportType +
                                '/ForCampaign/' +
                                $scope.campaign.CampaignID +
                                '/Export/' +
                                exportFormat;

            var form = angular.element(document.querySelector('#toDownload'));
            form.context.action = urlToDownload;
            form.submit();
        }
    }
})();